export default {
	url_api: 'https://admin.goandromeda.io/api/1',
	//url_api: (window.location.href.indexOf('localhost') != -1) ? 'http://andromeda.test/api/1' : 'https://admin.goandromeda.io/api/1',
	url_file_server: 'https://files.andromeda.im/api/1',
    url_img: 'https://res.cloudinary.com/demux',
	docentesPuedenMandarMensajesADocentes: true,
	docentesPuedenMandarMensajesAPadres: true,
	padresPuedenResponderMensajes: true
}